import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import scrollLock from './functions/_scrollLock.js' // スクロールロック

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {
  history.scrollRestoration = 'manual' // スクロール位置を保存しない

  gsap.registerPlugin(ScrollTrigger) // スクロールトリガー起動

  scrollLock('body', '#topLock') // スクロール固定

  //  ####    #####  #####   ##   ##   ####
  //  ##  ##  ##     ##  ##  ##   ##  ##
  //  ##  ##  #####  #####   ##   ##  ##  ###
  //  ##  ##  ##     ##  ##  ##   ##  ##   ##
  //  ####    #####  #####    #####    ####
  /* global debug */
  // if (typeof debug !== 'undefined') {
  //   console.log('debug')
  //   setCookie('topVideo', '', 0) // 再生完了フラグを除去
  // }

  //   ####  #####     ####             ####  #####  ######
  //  ##     ##  ##   ##               ##     ##       ##
  //   ###   #####    ##     ########   ###   #####    ##
  //     ##  ##  ##   ##                  ##  ##       ##
  //  ####   ##   ##   ####            ####   #####    ##
  // PCSPごとに動画ソースをセット
  const video = document.getElementById('topVideo')
  if (window.matchMedia('(min-width:951px)').matches) {
    //PC
    const videoSrc = document.getElementById('topVideo-pc')
    video.src = videoSrc.dataset.src
    video.poster = videoSrc.dataset.poster
  } else {
    //SP
    const videoSrc = document.getElementById('topVideo-sp')
    video.src = videoSrc.dataset.src
    video.poster = videoSrc.dataset.poster
  }

  let isSkipBtn = false // スキップボタンフラグ

  //  ##       #####     ###    ####
  //  ##      ##   ##   ## ##   ##  ##
  //  ##      ##   ##  ##   ##  ##  ##
  //  ##      ##   ##  #######  ##  ##
  //  ######   #####   ##   ##  ####
  // .js-loadingタグが付いた要素のsrcが全てロード完了したら特定の処理を実行
  // 30秒でタイムアウトして強制的に次に移る
  // sourceタグのsrc属性は監視できない
  loadingWait()
  function loadingWait() {
    const loadList = document.getElementsByClassName('js-loading')
    let isActive = false // 実行中フラグ

    if (~location.href.indexOf('?start')) {
      // TOPに戻るボタンから来ていたらスキップ
      loadingEnd()
    }

    // ロード完了した要素を数えて完了の成否を返す
    function loadedCheck() {
      if (isActive) {
        // 既に実行中ならスキップ
        return false
      }
      isActive = true
      for (const item of loadList) {
        if (!item.complete && item.readyState !== 4) {
          // ロード完了していないアイテムがあればfalse
          isActive = false
          return false
        }
      }
      return true
    }

    // 監視処理
    const checkLoop = setInterval(() => {
      if (loadedCheck()) {
        loadingEnd()
      }
    }, 1)

    // タイムアウトしたら強制的に終了処理
    const timeout = setTimeout(() => {
      loadingEnd()
    }, 30000)

    // 完了時の処理
    function loadingEnd() {
      // ロード画面を消す
      document.getElementById('loading').classList.add('hide')
      // タイマーを解除
      clearTimeout(timeout)
      clearInterval(checkLoop)
      // 次の処理を実行
      startSplash()
    }
  }

  //   ####  #####   ##        ###     ####  ##   ##
  //  ##     ##  ##  ##       ## ##   ##     ##   ##
  //   ###   #####   ##      ##   ##   ###   #######
  //     ##  ##      ##      #######     ##  ##   ##
  //  ####   ##      ######  ##   ##  ####   ##   ##
  function startSplash() {
    const base = document.getElementById('startSplash')

    const topVideo = getCookie('topVideo') // Cookie取得
    if (topVideo === 'done') {
      // 再生完了フラグがあればスキップ
      skipSplash()
      return
    }
    if (~location.href.indexOf('?start')) {
      // TOPに戻るボタンから来ていたらスキップ
      history.pushState(null, null, './') // URL変更
      skipSplash()
      return
    }

    // スキップボタンを押して強制終了
    window.addEventListener('click', function (e) {
      // 指定のIDを持つ
      if (e.target.id === 'topVideo-skip') {
        isSkipBtn = true
        skipSplash()
      }
    })

    const line = document.getElementById('startSplash-line')
    const shutterTop = document.getElementById('startSplash-shutterTop')
    const shutterBottom = document.getElementById('startSplash-shutterBottom')
    const text = document.getElementById('startSplash-text')

    text.classList.add('active')

    text.addEventListener('transitionend', function (e) {
      textEnd()
    })
    text.addEventListener('webkitTransitionend', function (e) {
      textEnd()
    })

    function textEnd() {
      setTimeout(() => {
        text.classList.add('hide')
        line.classList.add('active')
      }, 2000)
    }

    line.addEventListener('transitionend', function (e) {
      lineEnd()
    })
    line.addEventListener('webkitTransitionend', function (e) {
      lineEnd()
    })

    function lineEnd() {
      setTimeout(() => {
        line.classList.add('hide')
        shutterTop.classList.add('active')
        shutterBottom.classList.add('active')

        base.classList.add('unClick')
        startVideo()
      }, 300)
    }

    function skipSplash() {
      base.classList.add('hide')
      endSplash()
    }

    function endSplash() {
      startVideo()
    }
  }

  //  ##   ##  ##  ####    #####   #####
  //  ##   ##  ##  ##  ##  ##     ##   ##
  //  ##   ##  ##  ##  ##  #####  ##   ##
  //   ## ##   ##  ##  ##  ##     ##   ##
  //    ###    ##  ####    #####   #####

  function startVideo() {
    const topVideo = getCookie('topVideo') // Cookie取得
    if (topVideo === 'done') {
      // 再生完了フラグがあればスキップ
      videoEnd()
      return
    }

    if (isSkipBtn) {
      // スキップボタン押下済みならスキップ
      videoEnd()
      return
    }

    if (~location.href.indexOf('?start')) {
      // TOPに戻るボタンから来ていたらスキップ
      history.pushState(null, null, './') // URL変更
      videoEnd()
      return
    }

    const video = document.getElementById('topVideo')
    if (!video) {
      videoEnd()
      return
    }

    document.getElementById('topVideo-frame').classList.add('active')

    // 再生ボタンをクリックでボタン等をどかして再生
    window.addEventListener('click', function (e) {
      // 指定のIDを持つ
      if (e.target.id === 'topVideo-play') {
        e.target.style.display = 'none'
        document.getElementById('topVideo-cover').style.display = 'none'
        video.play()
      }
    })
    // スキップボタンを押して強制終了
    window.addEventListener('click', function (e) {
      // 指定のIDを持つ
      if (e.target.id === 'topVideo-skip') {
        video.pause()
        videoEnd()
      }
    })

    // 再生終了
    video.addEventListener(
      'ended',
      function () {
        setCookie('topVideo', 'done', 60 * 60 * 3, false) // 再生完了フラグを3時間付与
        videoEnd()
      },
      false
    )
  }
  function videoEnd() {
    document.getElementById('topVideo-frame').classList.remove('active')
    document.getElementById('topLock').classList.remove('active')
    scrollLock('body', '#topLock') // スクロール固定解除
    document.getElementById('topCloud').classList.add('animated')
    document.getElementById('topVideo-skip').classList.add('hide')
  }

  //   ####  ##       #####   ##   ##  ####
  //  ##     ##      ##   ##  ##   ##  ##  ##
  //  ##     ##      ##   ##  ##   ##  ##  ##
  //  ##     ##      ##   ##  ##   ##  ##  ##
  //   ####  ######   #####    #####   ####

  gsap.utils.toArray('.js-topCloud').forEach((wrap) => {
    const x = wrap.dataset.x || -100 // data-xからパララックス量取得
    const y = wrap.dataset.y || -100 // data-yからパララックス量取得

    gsap.fromTo(
      wrap,
      {
        xPercent: 0,
        yPercent: 0,
      },
      {
        duration: 1,
        xPercent: x,
        yPercent: y,
        scrollTrigger: {
          trigger: '#timeline-cloud', // ターゲット要素
          scrub: 1, // 補正倍率
          start: 'top', // 開始位置
        },
      }
    )
  })

  //   ####  #####  ######  ##   ##  #####
  //  ##     ##       ##    ##   ##  ##  ##
  //   ###   #####    ##    ##   ##  #####
  //     ##  ##       ##    ##   ##  ##
  //  ####   #####    ##     #####   ##
  gsap.to('#timeline-setup', {
    scrollTrigger: {
      trigger: '#timeline-setup', // ターゲット要素
      duration: 1,
      scrub: 1, // 補正倍率
      start: 'top', // 開始位置
      onEnter: function (elem) {
        // トリガーを通過した場合
        setupPartHide()
      },
      onLeave: function (elem) {
        // トリガーを完全に通過した場合
        setupPartShow()
      },
      onEnterBack: function (elem) {
        // トリガーを完全に通過した後、通過した方向から再度トリガーを通過した場合
        setupPartHide()
      },
    },
  })

  function setupPartShow() {
    gsap.to('#header', { opacity: 1, pointerEvents: 'auto' })
    gsap.to('#topScroll', { opacity: 0, pointerEvents: 'none' })
    gsap.to('#frontCloud', { yPercent: 0 })
  }
  function setupPartHide() {
    gsap.to('#header', { opacity: 0, pointerEvents: 'none' })
    gsap.to('#topScroll', { opacity: 1, pointerEvents: 'auto' })
    gsap.to('#frontCloud', { yPercent: -100 })
  }

  //  ##  ##     ##  ######  #####     #####
  //  ##  ####   ##    ##    ##  ##   ##   ##
  //  ##  ##  ## ##    ##    #####    ##   ##
  //  ##  ##    ###    ##    ##  ##   ##   ##
  //  ##  ##     ##    ##    ##   ##   #####
  gsap
    .timeline()
    .set('#introText', { autoAlpha: 0, yPercent: 100 })
    .fromTo(
      '#introText',
      {
        //初期状態
        autoAlpha: 1,
        yPercent: 100,
      },
      {
        //完了状態

        duration: 1,
        autoAlpha: 1,
        yPercent: 0,
        autoKill: false,

        scrollTrigger: {
          trigger: '#timeline-intro', // ターゲット要素
          scrub: 1, // 補正倍率
          start: 'top', // 開始位置
          onLeave: function (elem) {
            // トリガーを完全に通過した場合
            partShow('.js-sectionPart--intro')
          },
          onEnterBack: function (elem) {
            // トリガーを完全に通過した後、通過した方向から再度トリガーを通過した場合
            partHide('.js-sectionPart--intro')
          },
        },
      }
    )
    .fromTo(
      '#introText',
      {
        //初期状態
        yPercent: 0,
        autoAlpha: 1,
      },
      {
        duration: 1,
        autoAlpha: 1,
        yPercent: -100,
        autoKill: false,

        scrollTrigger: {
          trigger: '#timeline-introHide', // ターゲット要素
          scrub: 1, // 補正倍率
          start: 'top', // 開始位置
          onEnter: function (elem) {
            // トリガーを通過した場合
            partHide('.js-sectionPart--intro')
          },
        },
      }
    )

  //            #####     ###    #####    ######
  //            ##  ##   ## ##   ##  ##     ##
  //  ########  #####   ##   ##  #####      ##
  //            ##      #######  ##  ##     ##
  //            ##      ##   ##  ##   ##    ##
  gsap.utils.toArray('.js-introPartHide').forEach((item) => {
    const x = item.dataset.x || -100 // data-xからパララックス量取得
    const y = item.dataset.y || -100 // data-yからパララックス量取得

    gsap.timeline().fromTo(
      item,
      {
        xPercent: 0,
        yPercent: 0,
        autoAlpha: 1,
      },
      {
        duration: 2,
        xPercent: 0,
        yPercent: 0,
        autoAlpha: 0,
        autoKill: false,
        scrollTrigger: {
          trigger: '#timeline-introPartHide', // ターゲット要素
          scrub: 1, // 補正倍率
          start: 'top', // 開始位置
        },
        stagger: {
          from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
          each: 0.1, // それぞれをずらしてアニメーション
        },
      }
    )
  })
  gsap.utils.toArray('.js-introPart').forEach((item) => {
    const x = item.dataset.x || -100 // data-xからパララックス量取得
    const y = item.dataset.y || -100 // data-yからパララックス量取得
    gsap.fromTo(
      item,
      {
        xPercent: x,
        yPercent: y,
        autoAlpha: 0,
      },
      {
        duration: 2,
        xPercent: 0,
        yPercent: 0,
        autoAlpha: 1,
        autoKill: false,
        scrollTrigger: {
          trigger: '#timeline-introPart', // ターゲット要素
          scrub: 1, // 補正倍率
          start: 'top', // 開始位置
        },
        stagger: {
          from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
          each: 0.1, // それぞれをずらしてアニメーション
        },
      }
    )
  })

  //  ##   ####  ##        ###    ##     ##  ####
  //  ##  ##     ##       ## ##   ####   ##  ##  ##
  //  ##   ###   ##      ##   ##  ##  ## ##  ##  ##
  //  ##     ##  ##      #######  ##    ###  ##  ##
  //  ##  ####   ######  ##   ##  ##     ##  ####

  gsap.utils.toArray('.js-sectionIsland').forEach((item) => {
    let x = item.dataset.x || -100 // data-xからパララックス量取得
    let y = item.dataset.y || -100 // data-yからパララックス量取得
    if (window.matchMedia('(max-width:950px)').matches) {
      //SP
      x = item.dataset.spX || x // data-sp-xからパララックス量取得
      y = item.dataset.spY || y // data-sp-yからパララックス量取得
    }

    let xEnd = item.dataset.xEnd || -2 // 島を戻す際の移動補正値
    let yEnd = item.dataset.yEnd || -2 // 島を戻す際の移動補正値

    const show = item.dataset.show
    const hide = item.dataset.hide
    const slug = item.dataset.slug
    const fade = slug + 'IslandFade'
    gsap
      .timeline()
      .set(item, { autoAlpha: 1, scale: 0 })
      .fromTo(
        item,
        {
          xPercent: x,
          yPercent: y,
          filter: ' blur(5px)',
          scale: 0,
          autoAlpha: 1,
        },
        {
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 1,
          autoKill: false,
          filter: 'blur(0px)',
          duration: 1,
          scale: 1,
          scrollTrigger: {
            trigger: '#timeline-' + show, // ターゲット要素
            scrub: 1, // 指定の倍率でスクロールに合わせて動く
            start: 'top', // 開始位置

            onLeave: function (elem) {
              // トリガーを完全に通過した場合
              partShow('.js-sectionPart--' + slug)

              if (slug === 'talk') {
                gsap.to('#backCloudSp-left', { autoAlpha: 0 })
              } else if (slug === 'blog') {
                gsap.to('#frontCloud', { autoAlpha: 0 })
              }
              endIslandFix(slug) // 不要な島を隠す
            },
            onEnterBack: function (elem) {
              // トリガーを完全に通過した後、通過した方向から再度トリガーを通過した場合
              partHide('.js-sectionPart--' + slug)
              if (slug === 'talk') {
                gsap.to('#backCloudSp-left', { autoAlpha: 1 })
              } else if (slug === 'blog') {
                gsap.to('#frontCloud', { autoAlpha: 0 })
              } else if (slug === 'gall') {
                gsap.to('#frontCloud', { autoAlpha: 1 })
              }
            },
          },
          stagger: {
            from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
            each: 0.1, // それぞれをずらしてアニメーション
          },
        }
      )
      .fromTo(
        item,
        {
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 1,
          filter: 'blur(0px)',
          scale: 1,
        },
        {
          duration: 1,
          xPercent: x * xEnd,
          yPercent: y * yEnd,
          autoAlpha: 1,
          autoKill: false,
          filter: ' blur(5px)',
          scale: 2,
          scrollTrigger: {
            trigger: '#timeline-' + hide, // ターゲット要素
            scrub: 1, // 指定の倍率でスクロールに合わせて動く
            start: 'top', // 開始位置

            onEnter: function (elem) {
              // トリガーを通過した場合
              partHide('.js-sectionPart--' + slug)
              if (slug === 'talk') {
                gsap.to('#backCloudSp-left', { autoAlpha: 1 })
              } else if (slug === 'blog') {
                gsap.to('#frontCloud', { autoAlpha: 1 })
              } else if (slug === 'comp') {
                gsap.to('#frontCloud', { autoAlpha: 1 })
              }
            },

            onLeave: function (elem) {
              // トリガーを完全に通過した場合
            },
            onEnterBack: function (elem) {
              // トリガーを完全に通過した後、通過した方向から再度トリガーを通過した場合
            },
            onLeaveBack: function (elem) {
              // トリガーを完全に通過した後、トリガーより上に戻って再度トリガーを通過した場合
              partShow('.js-sectionPart--' + slug)
            },
          },
          stagger: {
            from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
            each: 0.1, // それぞれをずらしてアニメーション
          },
        }
      )
      .to(
        item,

        {
          autoAlpha: 0,
          scrollTrigger: {
            trigger: '#timeline-' + fade, // ターゲット要素
            scrub: 1, // 指定の倍率でスクロールに合わせて動く
            start: 'top', // 開始位置
          },
          stagger: {
            from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
            each: 0.1, // それぞれをずらしてアニメーション
          },
        }
      )
      .set(item, { autoAlpha: 1, scale: 0 })
  })
  //  #####     ###    #####    ######
  //  ##  ##   ## ##   ##  ##     ##
  //  #####   ##   ##  #####      ##
  //  ##      #######  ##  ##     ##
  //  ##      ##   ##  ##   ##    ##
  // 各セクションのパーツを島に合わせて出し入れ
  partSet()
  function partSet() {
    gsap.utils.toArray('.js-sectionPart').forEach((item) => {
      const x = item.dataset.x || -100 // data-xからパララックス量取得
      const y = item.dataset.y || -100 // data-yからパララックス量取得
      gsap.set(item, {
        xPercent: x,
        yPercent: y,
        autoAlpha: 0,
        autoKill: false,
      })
    })
  }
  function partShow(selector) {
    gsap.utils.toArray(selector).forEach((item) => {
      const x = item.dataset.x || -100 // data-xからパララックス量取得
      const y = item.dataset.y || -100 // data-yからパララックス量取得
      gsap.fromTo(
        item,
        {
          xPercent: x,
          yPercent: y,
          autoAlpha: 0,
        },
        {
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 1,
          duration: 1, //何秒かけてアニメーションを100%まで進めるか
          autoKill: false,
          stagger: {
            from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
            each: 0.3, // それぞれをずらしてアニメーション
          },
        }
      )
    })
  }
  function partHide(selector) {
    gsap.utils.toArray(selector).forEach((item) => {
      const x = item.dataset.x || -100 // data-xからパララックス量取得
      const y = item.dataset.y || -100 // data-yからパララックス量取得
      gsap.fromTo(
        item,
        {
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 1,
        },
        {
          xPercent: 0,
          yPercent: 0,
          autoAlpha: 0,
          duration: 1, //何秒かけてアニメーションを100%まで進めるか
          autoKill: false,
          stagger: {
            from: 'start', //start = 要素順にアニメーション。 start、center、edges、random、endで指定可能
            each: 0.3, // それぞれをずらしてアニメーション
          },
        }
      )
    })
  }

  //  #####  ##  ##    ##
  //  ##     ##   ##  ##
  //  #####  ##    ####
  //  ##     ##   ##  ##
  //  ##     ##  ##    ##
  // 通過した島を完全に消す
  function endIslandFix(nowSlug) {
    gsap.utils.toArray('.js-islandFix').forEach((item) => {
      const slug = item.dataset.slug
      if (nowSlug === slug) {
        // 現在の島は消さずにスキップ
        return
      }
      gsap.to(item, {
        autoAlpha: 0,
        duration: 0.5, //何秒かけてアニメーションを100%まで進めるか
        delay: 1, // 待機秒数
        autoKill: false,
      })
    })
  }

  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (e.target.classList.contains('js-quickJump')) {
      setTimeout(() => {
        endIslandFix('')
        partHide('.js-sectionPart')
        partHide('.js-sectionIsland')
        partHide('#introText')
      }, 500)
    }
  })
}
